<template>
 <div class="ui vertical segment">
    <app-header v-if="showMenu" ></app-header>
    <div class="ui container">
      <div id="demo" class="ui vertical stripe segment">
        <div id="content" class="ui basic segment">
          <h4 class="ui header">Delete Document(s)</h4>
          <div >
                <div class="ui left aligned nine wide column">
                    <div class="ui labeled icon input">
                      <div class="ui label">From Date:</div>
                      <Datepicker ref="startDate" v-model="fromDate" required format="dd MMM yyyy"   class="ui input" style="width:300px"></Datepicker>
                    
                    </div>
                     <div class="ui labeled icon input">
                      <div class="ui label">To Date:</div>
                        <Datepicker ref="endDate" v-model="endDate"  id="endDate"  class="ui input" style="width:300px"></Datepicker>
                    
                    </div>
                  </div>
              <br />
            </div><!-- ui grid -->
            <div class="ui grid">
                <div class="ui left aligned nine wide column">
                   <div class="ui labeled icon input">
                      <div class="ui label">Community:</div>
                       <select class="ui input" style="width:300px"  v-model="communitySelected"  @change="communityChangedValue()" >
                      <option v-for="community in communities" v-bind:value="community.community_id" v-bind:key="community.community_id" >
                          {{ community.community_name }}
                      </option>
                    </select>
                    
                    </div>
                    <button class="ui button primary" @click="setFilter">Search</button>
                    <button class="ui button primary" @click="deleteData">Delete</button>
                    <!--<button class="ui button" @click="resetFilter">Reset</button> -->
                </div>
                <div class="ui right aligned seven wide column">
                  <button class="ui basic button" id="settingsBtn" @click="showSettingsModal">
                    <i class="setting icon"></i>
                    Settings
                  </button>
                </div>
              
            &nbsp;&nbsp;&nbsp;&nbsp;<div class="ui red label" v-if="isEmpty" >
            Please select from and to dates.
           </div>
            <div class="ui red label" v-if="isSelect" >
            Please select the row(s) to delete.
           </div>

            </div><!-- ui grid -->
            <div :class="[{'vuetable-wrapper ui basic segment': true}, loading]">
              <vuetable ref="vuetable"
                api-url= "invoices/"
                :http-options="httpOptions"
                :http-fetch="fetchData"
                :fields="fields"
                :table-height="tableHeight"
                pagination-path="pagination"
                :sort-order="sortOrder"
                :multi-sort="multiSort"
                :per-page="perPage"
                :append-params="moreParams"
                 detail-row-component="invoice-detail-row"
                detail-row-transition="expand"
                :row-class="rowClassCB"
                @vuetable:pagination-data="onPaginationData"
                @vuetable:load-success="onLoadSuccess"
                 @vuetable:load-error="onLoadError"
                @vuetable:loading="showLoader"
                @vuetable:loaded="hideLoader"
                @vuetable:cell-clicked="onCellClicked"
                @vuetable:initialized="onInitialized"
                @vuetable:data-reset="onDataReset"
                track-by="transaction_id"
              ></vuetable>
              <div class="vuetable-pagination ui bottom attached segment grid">
                <vuetable-pagination-info ref="paginationInfo"
                  :info-template="paginationInfoTemplate"
                ></vuetable-pagination-info>
                <component :is="paginationComponent" ref="pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></component>
              </div>
          </div><!-- vuetable-wrapper -->
          <invoice-settings-modal ref="settingsModal"
              :vuetable-fields="vuetableFields"
          ></invoice-settings-modal>
        </div><!-- content -->
      </div><!-- app -->
    </div><!-- ui container -->
   
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.2.2/semantic.min.css" media="screen" title="no title" charset="utf-8"> 
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/sweetalert/1.1.3/sweetalert.min.css">
   
  </div>
</template>

<script>
import axios from 'axios'
import Vuetable from '@/components/vuetable-2/Vuetable.vue'
import VuetablePagination from '@/components/vuetable-2/VuetablePagination.vue'
import VuetablePaginationDropdown from '@/components/vuetable-2/VuetablePaginationDropdown.vue'
import VuetablePaginationInfo from '@/components/vuetable-2/VuetablePaginationInfo.vue'
import Vue from 'vue'
import Header from '@/components/Header.vue';
import InvoiceDetailRow from './InvoiceDetailRow'
import InvoiceSettings from './InvoiceSettings'
import Datepicker from 'vuejs-datepicker';

let E_SERVER_ERROR = 'Error communicating with the server'

/* Detail Row  */
Vue.component('invoice-detail-row', InvoiceDetailRow)
Vue.component('invoice-settings-modal',InvoiceSettings)




let tableColumns = [
  {
    name: '__checkbox',
    dataClass: 'left aligned',
    width: '30px'
  },
  {
    name: 'transaction_id',
    title: 'Transaction ID',
    dataClass: 'left aligned',
    sortField: 'transaction_id',
    width: '92px'
  },
  {
    name: 'invoice_number',
    dataClass: 'left aligned',
    title: 'Invoice Number',
    sortField: 'invoice_number',
    width: '100px',
 },
  {
    name: 'curr_code',
    title: 'Currency Code',
    width: '92px',
    sortField: 'curr_code',
    dataClass: 'left aligned',
  },
  {
    name: 'invoice_date',
    title: 'Invoice Date',
    sortField: 'invoice_date',
    titleClass: 'left aligned',
    dataClass: 'left aligned',
    callback: 'formatDate|MM-DD-YYYY',
    width: '83px',
  },
  {
    name: 'purchase_order_number',
    title: 'PO#',
    titleClass: 'left aligned',
    sortField: 'purchase_order_number',
    dataClass: 'left aligned',
    width: '145px'
  },
  {
    name: 'sale_total',
    title: 'Sale Total',
    sortField: 'sale_total',
    titleClass: 'left aligned',
    dataClass: 'left aligned',
    width: '75px'
  },
  {
    name: 'date_received',
    title: 'Date Received',
    sortField: 'date_received',
    titleClass: 'left aligned',
    dataClass: 'left aligned',
    callback: 'formatDate|MM-DD-YYYY',
    width: '90px',
  }
]

export default {
    components: {
    appHeader: Header,
    Vuetable,
    VuetablePagination,
    VuetablePaginationDropdown,
    VuetablePaginationInfo,
    Datepicker
  },
  data () {
    return {
    showMenu : true,
    isEmpty : false,
    isSelect : false,
    tokenExpired : 0,
    communities : [],
    communitySelected : "",
     httpOptions: {
              headers: {
                  authorization: 'bearer ' + sessionStorage.getItem('id_token')
              }
          },
    loading: '',
    searchFor: '',
    moreParams: { startdate: '', enddate: '' },
    fields: tableColumns,
    tableHeight: '',
    vuetableFields: false,
    sortOrder: [{
        field: 'date_received',
        direction: 'desc',
    }],
    multiSort: true,
    paginationComponent: 'vuetable-pagination',
    perPage: 10,
    paginationInfoTemplate: 'Showing record: {from} to {to} from {total} item(s)',
    isCheckAll: false,
    fromDate : '',
    endDate : '',
     input: {
              trasactionids : [],
              community_id : ""
            }
 }
  },
  watch: {
    'perPage' (val, oldVal) {
      this.$nextTick(function() {
        this.$refs.vuetable.refresh()
      })
    },
    'paginationComponent' (val, oldVal) {
      this.$nextTick(function() {
        this.$refs.pagination.setPaginationData(this.$refs.vuetable.tablePagination)
      })
    }
  },
  created(){
      if(!sessionStorage.getItem('id_token'))this.$router.push({name: 'Login'});
    this.bindCommunity();
    
  },
  methods: {
    selectAll(value){
     this.$refs.vuetable.toggleAllCheckboxes('__checkbox', {target: {checked: value}})
    },
     bindCommunity(){
        if(sessionStorage.getItem('id_token')){
         axios({ method: "GET", "url": Vue.prototype.$hostname + "lookup/community", 
               "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + sessionStorage.getItem('id_token') 
                } }).then
                (
                    result => {
                    this.communities = result.data;
                    this.communitySelected  = "999";
                    sessionStorage.setItem('communitySelected', this.communitySelected);
                    /*this.communitySelected = this.$route.query.comId;*/
                   }, 
                error => {
                    console.error(error);
                    this.sessionExpired(error.response.status);
                });
        } 
    },
    communityChangedValue(){
        /* this.fetchData(); 
       this.$refs.vuetable.refresh();
      */
     /*
     this.$refs.vuetable.refresh();
     this.vuetableFields = fields
     this.onChangePage (2);*/
    },
    sessionExpired(errorStatus){
      if ((errorStatus === 403 || errorStatus === 401) && this.tokenExpired === 0 ) {
        this.tokenExpired = 1;
        alert('Sesssion expired.Please login again!!')
        
       /* this.$router.push({name: 'Login'});*/
    }
   },
    transform (data) {
      let transformed = {}
      transformed.pagination = {
        total: data.total,
        per_page: data.per_page,
        current_page: data.current_page,
        last_page: data.last_page,
        next_page_url: data.next_page_url,
        prev_page_url: data.prev_page_url,
        from: data.from,
        to: data.to
      }

      transformed.data = []
      data = data.data
      for (let i = 0; i < data.length; i++) {
        transformed['data'].push({
          id: data[i].id,
          transaction_id : data[i].transaction_id,
          invoice_number: data[i].invoice_number,
          curr_code: data[i].curr_code,
          invoice_date: data[i].invoice_date,
          purchase_order_number : data[i].purchase_order_number,
          sale_total: data[i].sale_total,
          vendor_name: data[i].vendor_name,
          buyer_name: data[i].buyer_name,
          city:data[i].city,
          date_received: data[i].date_received,
          community_id : data[i].community_id
          })
      }

      return transformed
    },
    fetchData: function(apiUrl, httpOptions) {
      this.isSelect = false;
      if(!this.communitySelected) {
          this.communitySelected = "999";
       }
     return axios.get(Vue.prototype.$hostname + apiUrl +  this.communitySelected, this.httpOptions); 
    },
    formatDate (value, fmt = 'D MMM YYYY') {
      return (value == null)
        ? ''
        : moment(value, 'YYYY-MM-DD').format(fmt)
    },
    showSettingsModal () {
      let self = this
      $('#settingsModal').modal({
        detachable: true,
        onVisible () {
          $('.ui.checkbox').checkbox()
        }
      }).modal('show')
    },
    showLoader () {
      this.loading = 'loading'
    },
    hideLoader () {
      this.loading = ''
    },
    allCap (value) {
      return value.toUpperCase()
    },
    formatDate (value, fmt) {
      if (value === null) return ''
      fmt = (typeof(fmt) === 'undefined') ? 'D MMM YYYY' : fmt
      return moment(value, 'YYYY-MM-DD').format(fmt)
    },
    gender (value) {
      return value === 'M'
        ? '<span class="ui teal label"><i class="male icon"></i>Male</span>'
        : '<span class="ui pink label"><i class="female icon"></i>Female</span>'
    },
    showDetailRow (value) {
      let icon = this.$refs.vuetable.isVisibleDetailRow(value) ? 'down' : 'right'
      return [
        '<a class="show-detail-row">',
            '<i class="chevron circle ' + icon + ' icon"></i>',
        '</a>'
      ].join('')
    },
    setFilter () {
        this.isSelect = false;
        this.moreParams['startdate'] = moment(this.fromDate).format('MM/DD/YYYY');
        this.moreParams['enddate'] = moment(this.endDate).format('MM/DD/YYYY');
        this.$refs.vuetable.selectedTo = [];
        if(this.fromDate != '' && this.endDate != '') {
        this.$refs.vuetable.refresh();
        this.isEmpty = false; 
        }else this.isEmpty = true; 

      
    },
    deleteData () {
      this.isEmpty = false;

      if(Object.keys(this.$refs.vuetable.selectedTo).length === 0 ) {
        this.isSelect = true;
      }else{
        this.isSelect = false;
       alert('Selected Transaction(s) : ' + this.$refs.vuetable.selectedTo);
        /* this.$refs.vuetable.selectedTo */
        this.input.trasactionids = this.$refs.vuetable.selectedTo;
        this.input.community_id = this.communitySelected;
        

         swal({
            title: "",
            text: "Are you sure, to delete? You won't be able to revert this!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Yes, Delete it!",
            closeOnConfirm: true
        },() => {
          this.showLoader();
            axios({ method: "POST", "url": Vue.prototype.$hostname + "deletedocumentsdata", 
                  "data": this.input, 
                    "headers": { 
                          "content-type": "application/json",
                          "authorization": "bearer " + sessionStorage.getItem('id_token')  } }).then
                    (
                        result => {
                        this.response = result.data;
                        this.$refs.vuetable.selectedTo = [];
                        this.$refs.vuetable.refresh();
                        this.isEmpty = false; 
                        sweetAlert('Data has been deleted successfully.', '', 'success')
    
                    }, 
            error => {
                alert('Error!!')
                  console.error(error);

                });  
        })




        

        }

        this.hideLoader();

      /*
      swal({
            title: "Delete selected document(s)?",
            text: "Are you sure? You won't be able to revert this!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Yes, Delete it!",
            closeOnConfirm: true
        },() => {
            alert(this.input);
        })
      */

    } ,
     resetFilter () {
      this.searchFor = ''
      this.setFilter()
    },
    preg_quote ( str ) {
       return (str+'').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1");
    },
    highlight (needle, haystack) {
      return haystack.replace(
        new RegExp('(' + this.preg_quote(needle) + ')', 'ig'),
        '<span class="highlight">$1</span>'
      )
    },
    rowClassCB (data, index) {
      return (index % 2) === 0 ? 'odd' : 'even'
    },
    /*
     * Example of defining queryParams as a function
     */
    // queryParams (sortOrder, currentPage, perPage) {
    //   return {
    //     'sort': sortOrder[0].field + '|' + sortOrder[0].direction,
    //     'order': sortOrder[0].direction,
    //     'page': currentPage,
    //     'per_page': perPage
    //   }
    // },
    onCellClicked (data, field, event) {
      console.log('cellClicked', field.name)
      if (field.name !== '__actions') {
        this.$refs.vuetable.toggleDetailRow(data.id)
      }
    },
    onCellDoubleClicked (data, field, event) {
      console.log('cellDoubleClicked:', field.name)
    },
    onCellRightClicked (data, field, event) {
      console.log('cellRightClicked:', field.name)
    },
    onLoadSuccess (response) {
     
      // set pagination data to pagination-info component
      this.$refs.paginationInfo.setPaginationData(response.data)

      let data = response.data.data
      if (this.searchFor !== '') {
        for (let n in data) {
          data[n].name = this.highlight(this.searchFor, data[n].name)
          data[n].email = this.highlight(this.searchFor, data[n].email)
        }
      }
    },
    onLoadError (response) {
      if (response.status == 400 &&  this.tokenExpired === 0) {
        sweetAlert('Something\'s Wrong!', response.data.message, 'error')
        his.$router.push({name: 'Login'});
      } else if (response.status == 403 || response.status == 401) {
        this.sessionExpired(response.status)
      }else {
       /* if(this.tokenExpired === 0){sweetAlert('Oops', E_SERVER_ERROR, 'error')*/
        this.$router.push({name: 'Login'});
       /* }*/
      }
    },
    onPaginationData (tablePagination) {
      this.$refs.paginationInfo.setPaginationData(tablePagination)
      this.$refs.pagination.setPaginationData(tablePagination)
    },
    onChangePage (page) {
            this.$refs.vuetable.changePage(page)
    },
    onInitialized (fields) {
      console.log('onInitialized', fields)
      this.vuetableFields = fields
    },
    onDataReset () {
      console.log('onDataReset')
      this.$refs.paginationInfo.resetData()
      this.$refs.pagination.resetData()
    }
}

}
</script>
 <style type="text/css">
      .ui.vertical.stripe h3 {
        font-size: 2em;
      }
      .secondary.pointing.menu .toc.item {
        display: none;
      }
      .vuetable {
        margin-top: 1em !important;
      }
      .vuetable-wrapper.ui.basic.segment {
        padding: 0em;
      }
      .vuetable button.ui.button {
        padding: .5em .5em;
        font-weight: 400;
      }
      .vuetable button.ui.button i.icon {
        margin: 0;
      }
      .vuetable td i.handle-icon:hover {
        cursor: pointer;
      }
      .vuetable-actions {
        width: 15%;
        padding: 12px 0px;
        text-align: center;
      }
      .vuetable-pagination {
        background: #f9fafb !important;
      }
      .vuetable-pagination-info {
        margin-top: auto;
        margin-bottom: auto;
      }
      .highlight {
        background-color: yellow;
      }
      .vuetable-detail-row {
        height: 200px;
      }
      .detail-row {
        margin-left: 40px;
      }
      .expand-transition {
        transition: all .5s ease;
      }
      .expand-enter, .expand-leave {
        height: 0;
        opacity: 0;
      }
      tr.odd {
        background-color: #e6f5ff;
      }
      body {
        overflow-y: scroll;
      }
    </style>

 
 
    



// WEBPACK FOOTER //
// src/components/manage-documents/InvoiceList.vue